import type { LabExperiment, LabInsightWithFeedback } from "~vue/Labs/types";

export interface MyWorkInsightRenderItem {
    experiment: Pick<LabExperiment, "id" | "slug" | "title">;
    insightWithFeedback: LabInsightWithFeedback;
}

export function orderMyWorkInsights(insights: MyWorkInsightRenderItem[]): MyWorkInsightRenderItem[] {
    return [...insights].sort((a, b) => {
        return a.insightWithFeedback.insight.title.localeCompare(b.insightWithFeedback.insight.title, undefined, {
            sensitivity: "base",
        });
    });
}
